import React, { useEffect, useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { CaretDownOutlined } from '@ant-design/icons';

const useStyles = makeStyles(
  theme => ({
    newFiltersBox: {
      position: 'relative',
      display: 'inline-block',
      textTransform: 'capitalize',
      color: '#9E9E9E',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      cursor: 'pointer',
      transition: 'all .3s',
    },

    filterUl: {
      minWidth: '100%',
      position: 'absolute',
      zIndex: 3,
      padding: '4px 0px',
      backgroundColor: theme.colors.gray1,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      borderRadius: '2px',
      maxHeight: '300px',
      overflow: 'overlay',
    },
    filtersli: {
      padding: '4px 12px',
      fontWeight: 'normal',
      whiteSpace: 'nowrap',
      listStyle: 'none',
      lineHeight: '24px',

      '&:hover': { backgroundColor: theme.colors.mainGreen1, cursor: 'pointer' },
    },
    defaultColor: {
      color: '#4C4C4C',
    },
    filterSvg: { fontSize: '12px', color: '#9E9E9E', marginLeft: '8px' },
    svgChange: {
      transform: 'rotateX(180deg)',
      transformOrigin: 'center',
    },
    choosenColor: {
      fontWeight: '500',
      color: '#38B2A6',
    },
  }),
  { name: 'NewFilters' },
);

const NewFilters = props => {
  const wrapperRef = useRef(null);
  const classes = useStyles();
  const { placeholder, value, onChange, options } = props;

  const [selectedValue, setSelectedValue] = useState(-1);

  const [showFilter, setShowFilter] = useState(false);

  const selectedText = useMemo(() => {
    const { text = placeholder } = options.find(item => item.value === selectedValue) ?? {};

    return text;
  }, [options, selectedValue]);

  const liClick = ({ value }) => {
    if (value !== selectedValue) {
      setSelectedValue(value);

      onChange?.(value);
    }
  };

  useEffect(() => {
    if (value !== undefined) {
      setSelectedValue(value);
    }
  }, [value]);
  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowFilter(false);
    }
  };
  useEffect(() => {
    document?.addEventListener('mousedown', handleClickOutside);
    return () => {
      document?.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  return (
    <div style={{ marginRight: '10px' }} ref={wrapperRef}>
      <div className={classes.newFiltersBox}>
        <div
          onClick={() => {
            setShowFilter(!showFilter);
          }}
        >
          {selectedText}
          <CaretDownOutlined
            className={`${classes.filterSvg} ${showFilter ? classes.svgChange : ''}`}
          />
        </div>

        {showFilter && (
          <ul className={classes.filterUl}>
            {options?.map(option => (
              <li
                key={`NewFilters ${option.value}`}
                className={`${classes.filtersli} ${
                  selectedValue === option.value ? classes.choosenColor : classes.defaultColor
                }`}
                onClick={() => {
                  liClick(option);
                  setShowFilter(!showFilter);
                }}
              >
                {option.text}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

NewFilters.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
};
export default NewFilters;
